import React from "react";
import { useField } from "formik";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import FormInputShell, { InputShell } from "./FormInputShell";
import { makeStyles } from "@mui/styles";
import { InputAdornment } from "@mui/material";

interface SimpleTextInputProps {
  label?: any;
  readOnly?: any;
  readonlyvalue?: any;
  customStyle?: any;
  adornment?: any;
  adornmentPosition?: string;
  button?: any;
  [key: string]: any;
}

const useStyles = makeStyles((theme) => ({
  menu: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  subLabel: {
    margin: 0,
    padding: 0,
    fontSize: 9,
    fontWeight: 600,
    color: theme.palette.common.black,
  },
  hideElement: {
    display: "none",
  },
  label: {
    margin: 0,
    padding: 0,
    fontSize: 16,
    // fontWeight: 600,
  },
  _label: {
    fontSize: "12px !important",
  },
  typography: {
    fontSize: 12,
    padding: 9,
    border: "1px solid grey",
    borderRadius: 5,
    color: theme.palette.common.grey,
  },
}));

const SimpleTextInput = ({
  label,
  readOnly,
  readonlyvalue,
  customStyle,
  adornment,
  adornmentPosition = "end",
  button,
  ...props
}: SimpleTextInputProps) => {
  const classes = useStyles();
  return (
    <InputShell label={label} name={props.name} button={button}>
      {readOnly ? (
        <Typography className={classes.typography}>
          {readonlyvalue || ""}
        </Typography>
      ) : (
        <TextField
          placeholder={props.placeholder || ""}
          variant="outlined"
          disabled={props.readOnly}
          inputProps={{ readOnly: props.readOnly, placeholder: props.placeholdertext || "", }}
          fullWidth
          rows={props.multiline ? 4 : 1}
          {...props}
          InputProps={{
            style: {
              height: 38,
              ...customStyle,
            },
            endAdornment: ![null, undefined].includes(adornment) && (
              <InputAdornment position={adornmentPosition as "start" | "end"}>
                {adornment}
              </InputAdornment>
            ),
          }}
        />
      )}
    </InputShell>
  );
};

const TextInput = (props: any) => {
  const [field, meta] = useField(props);
  const { readOnly, InputProps, ...otherProps } = props;

  return readOnly ? (
    <Typography variant="body1" gutterBottom>
      {field.value}
    </Typography>
  ) : (
    <TextField
      variant="outlined"
      disabled={readOnly}
      inputProps={{ readOnly }}
      fullWidth
      error={!!(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
      rows={otherProps.multiline ? 4 : 1}
      rowsmax={otherProps.multiline ? Infinity : 1}
      {...field}
      {...otherProps}
      InputProps={{
        style: {
          height: 38,
        },
        ...InputProps,
      }}
    />
  );
};

const FormTextInput = ({ label, ...props }: any) => {
  return (
    <FormInputShell label={label} name={props.name}>
      <TextInput {...props} />
    </FormInputShell>
  );
};

// @ts-ignore - MUI TextField component doesn't expose propTypes in TypeScript
FormTextInput.propTypes = TextField.propTypes;

export default FormTextInput;
export { TextInput, SimpleTextInput };
